import { findBom, findBomTool } from './findBom'
import { getBomContent, getBomContentTool } from './getBomContent'

export const tools = [findBomTool, getBomContentTool]

export const toolFunctions = {
  findBom,
  getBomContent,
}
